import React from 'react';
import SectionHeader from './SectionHeader';
import { useReveal } from '../../hooks/useReveal';

interface SectionProps {
  id: string;
  title: string;
  eyebrow?: string | undefined;
  intro?: React.ReactNode | undefined;
  className?: string;
  children: React.ReactNode;
}

/** A page section with the shared header, content width, vertical rhythm, and entrance reveal. */
const Section: React.FC<SectionProps> = ({ id, title, eyebrow, intro, className, children }) => {
  const headingId = `${id}-heading`;
  const revealRef = useReveal<HTMLDivElement>();
  return (
    <section id={id} className={['ui-section', className].filter(Boolean).join(' ')} aria-labelledby={headingId}>
      <div ref={revealRef} className="ui-section__inner reveal">
        <SectionHeader id={headingId} title={title} eyebrow={eyebrow} intro={intro} />
        {children}
      </div>
    </section>
  );
};

export default Section;
